import type { Ref } from 'vue';
import type { TranslatableText } from 'types/api/settings/invoicing/invoicingConditionsTypes';

export function useTranslatableText(translatableText: Ref<TranslatableText>) {
    const getTranslationValue = (langId: number | string): string => {
        const numericLangId = Number(langId);
        const translation = translatableText.value.translations.find(
            (translationItem) => translationItem.langId === numericLangId,
        );
        return translation?.value ?? '';
    };

    const updateTranslationValue = (langId: number | string, value: string): void => {
        const numericLangId = Number(langId);
        const translations = [...translatableText.value.translations];
        const index = translations.findIndex(
            (translation) => translation.langId === numericLangId,
        );
        if (index >= 0) {
            translations[index] = { ...translations[index], value };
        } else {
            translations.push({ langId: numericLangId, value });
        }
        translatableText.value = {
            ...translatableText.value,
            translations,
        };
    };

    const updateDefaultValue = (value: string): void => {
        translatableText.value = {
            ...translatableText.value,
            value,
        };
    };

    return { getTranslationValue, updateTranslationValue, updateDefaultValue };
}
